import { createSlice } from "@reduxjs/toolkit";

export const areaManagerSlice = createSlice({
  name: "areaManager",
  initialState: {
    loading: false,
    areaManagerList: [],
    listCount: 0,
    model: false,
    error_msg: null,
    rowdata: {},
    managerList: [],
    managerParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
    },
    areaManagerParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
  },
  reducers: {
    getAreaManagers: (state) => ({ ...state, loading: true }),
    areaManagerListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.response.count / state.areaManagerParams.page_size
      );
      return {
        ...state,
        listCount: action.payload.response.count,
        areaManagerList: action.payload.response.results,
        loading: false,
        areaManagerParams: { ...state.areaManagerParams, no_of_pages: noofpages },
      };
    },
    areaManagerAdd: (state) => ({ ...state, loading: true }),
    areaManagerAddSuccessful: (state) => ({
      ...state,
      loading: false,
      model: false,
      rowdata: {},
    }),
    areaManagerEdit: (state, action) => ({
      ...state,
      model: true,
      rowdata: action.payload,
    }),
    areaManagerDelete: (state) => ({ ...state, loading: false }),
    InputChangeValue: (state, action) => ({
      ...state,
      rowdata: { ...state.rowdata, [action.payload.key]: action.payload.value },
    }),
    isModelVisible: (state, action) => {
      if (!action.payload) return { ...state, model: false, rowdata: {} };
      return { ...state, model: true };
    },
    SetAreaManagerParams: (state, action) => ({
      ...state,
      areaManagerParams: action.payload,
    }),
    getManagerList: (state) => state,
    managerListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.count / state.managerParams.page_size
      );
      return {
        ...state,
        managerList:
          state.managerParams.page === 1
            ? action.payload.results
            : [...state.managerList, ...action.payload.results],
        managerParams: { ...state.managerParams, no_of_pages: noofpages },
      };
    },
    setManagerParams: (state, action) => ({
      ...state,
      managerParams: action.payload,
    }),
    apiError: (state, action) => ({
      ...state,
      loading: false,
      error_msg: action.payload,
    }),
  },
});

export const {
  getAreaManagers,
  areaManagerListSuccessful,
  areaManagerAdd,
  areaManagerAddSuccessful,
  areaManagerEdit,
  areaManagerDelete,
  InputChangeValue,
  isModelVisible,
  SetAreaManagerParams,
  getManagerList,
  managerListSuccessful,
  setManagerParams,
  apiError,
} = areaManagerSlice.actions;

export default areaManagerSlice.reducer;
